import { render, staticRenderFns } from "./pubPagination.vue?vue&type=template&id=7514f261&scoped=true&"
import script from "./pubPagination.vue?vue&type=script&lang=js&"
export * from "./pubPagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7514f261",
  null
  
)

export default component.exports